<template>
  <div class="payment-list">
    <van-nav-bar title="收费记录" fixed />
    <div class="content">
      <van-list v-model="loading" :finished="finished" @load="onLoad">
        <van-card
          v-for="item in list"
          :key="item.id"
          :title="item.plateNumber"
          :desc="item.parkingLotName"
        >
          <template #tags>
            <van-tag :type="item.paymentStatus === 'paid' ? 'success' : 'danger'">
              {{item.paymentStatus === 'paid' ? '已支付' : '未支付'}}
            </van-tag>
          </template>
          <template #price>
            <span style="color: #ff7e00; font-size: 18px;">¥{{item.amount}}</span>
          </template>
          <template #footer>
            <van-button v-if="item.paymentStatus === 'unpaid'" size="small" type="primary" @click="handlePay(item.id)">
              支付
            </van-button>
          </template>
        </van-card>
      </van-list>
    </div>
  </div>
</template>

<script>
import { paymentApi } from '@/api'

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false
    }
  },
  methods: {
    async onLoad() {
      try {
        const { data } = await paymentApi.getList()
        this.list = data
        this.finished = true
      } catch (error) {
        this.$toast.fail('加载失败')
      }
      this.loading = false
    },
    async handlePay(id) {
      this.$dialog.confirm({ message: '确定支付?' }).then(async () => {
        await paymentApi.pay(id)
        this.$toast.success('支付成功')
        this.onLoad()
      })
    }
  }
}
</script>

<style scoped>
.payment-list {
  padding-top: 46px;
}
.content {
  padding: 16px;
}
.van-card {
  margin-top: 12px;
}
</style>
